
import {defineComponent} from 'vue'

export default defineComponent({
  name: 'LabelsInput',
  props: {
    modelValue: { type: Array as () => string[], required: true },
    disabled: { type: Boolean, required: false, default: false },
    placeholder: { type: String, required: false },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      newLabel: '' as string,
      error: '' as string,
    }
  },
  methods: {
    add(): void {
      this.error = '';
      const value = (this.newLabel || '').trim();
      if (!value) {
        return;
      }
      const labels = [...(this.modelValue || [])];
      if (labels.length >= 10) {
        this.error = this.$t('maxLabelsExceeded') as string;
        return;
      }
      if (value.length > 50) {
        this.error = this.$t('labelTooLong') as string;
        return;
      }
      if (labels.find(l => l.toLowerCase() === value.toLowerCase())) {
        this.error = this.$t('duplicateLabel') as string;
        return;
      }
      labels.push(value);
      this.$emit('update:modelValue', labels);
      this.newLabel = '';
    },
    remove(index: number): void {
      this.error = '';
      const labels = [...(this.modelValue || [])];
      labels.splice(index, 1);
      this.$emit('update:modelValue', labels);
    }
  }
})
